// extracted by mini-css-extract-plugin
export default {"form":"EditarClienteGlobal_form__q0BXF","areaBtn":"EditarClienteGlobal_areaBtn__2eCB4","btn":"EditarClienteGlobal_btn__S5Sks"};